import React, { useEffect, useState } from 'react'
import { getData } from '../../services/api'
import { Box, Grid } from '@mui/material'

export default function DailySummary() {
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const getDataItem = async () => {

        setIsLoading(true)
        const res = await getData('dashboard/back/daily-summary')
        if (res.status === true) {
            setData(res.result)
            setIsLoading(false)
        }
    }
    useEffect(() => {
        getDataItem()
    }, [])
    return (
        <Grid container spacing={2}>
            <Grid item md={6} xs={12} >
                <div class="border-lights" style={{textAlign:"center"}}>

                    <h5>เมล็ดพันธุ์คงคลัง ปีงบประมาณ {data?.BudgetYear}</h5>
                    <p>แผนผลิต  {(+(data?.ProductionPlan / 1000).toFixed(2))?.toLocaleString()}  ตัน</p>
                    <p>ผลิตสะสม {(+(data?.ReceiveTotal / 1000).toFixed(2))?.toLocaleString()} ตัน ( {data?.ProducePercent?.toFixed(2)} % )</p>
                    <p>( วันนี้ + {(+(data?.ReceiveTotal / 1000).toFixed(2))?.toLocaleString()}  ตัน )</p>
                </div>
            </Grid>
            <Grid item md={6} xs={12}>
                <div class="border-lights" style={{textAlign:"center"}}>
                    <h5>การจำหน่าย ปีงบประมาณ {data?.BudgetYear}</h5>
                    <p>คงคลัง  {(+(data?.StockBalance / 1000).toFixed(2))?.toLocaleString()}  ตัน</p>
                    <p>จำหน่ายสะสม  {(+(data?.SaleTotal / 1000).toFixed(2))?.toLocaleString()}  ตัน ( {data?.SalePercent?.toFixed(2)} % )</p>
                    <p>( วันนี้ + {(+(data?.SaleToday / 1000).toFixed(2))?.toLocaleString()}  ตัน )</p>
                    <p>สะสมเป็นเงิน  {(+(data?.IncomeTotal / 1000000).toFixed(2))?.toLocaleString()} ล้านบาท</p>
                    <p>( วันนี้ + {(+(data?.IncomeToday / 1000000).toFixed(2))?.toLocaleString()} ล้านบาท )</p>
                </div>
            </Grid>
        </Grid>
    )
}
